var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"Component",attrs:{"size":_vm.normalizedSize,"color":_vm.normalizedColor,"filled":_vm.filled}})}
var staticRenderFns = []

export { render, staticRenderFns }